import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="gf-pagehead">
      <h1>Page not found</h1>
      <p className="sub">
        There is no Giraffe page at this address. <Link to="/">Go to Home</Link>
      </p>
    </div>
  );
}
